import { Component, OnInit } from '@angular/core';
import { Utilservice } from '@core/services/util.service';
import { CartaoService } from '@modules/cartao/services/cartao.service';
import { UserTypes } from '@shared/enums';
import { User } from '@shared/models';
import * as toastr from 'toastr'

@Component({
  selector: 'app-cartao',
  templateUrl: './cartao.component.html',
  styleUrls: ['./cartao.component.css']
})
export class CartaoComponent implements OnInit {

  cnpj = "";
  nomeLoja = "";
  nomeContato = "";
  ddd1 = "";
  tel1 = "";
  ddd2 = "";
  tel2 = "";

  userLogado: User;

  lsClients: any[] = [];

  isRequesting: boolean = false;

  constructor(private cartaoService: CartaoService) { }

  ngOnInit() {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);

    this.getClients();

  }

  saveClienteCartao(){

    if(this.nomeContato == ""){
      toastr.error('Campo "NOME DE CONTATO" é obrigatório!');
      return;
    }

    if(this.tel1 == "" && this.tel2 == "" && this.ddd1 == "" && this.ddd2 == ""){
      toastr.error('Pelomenos um telfone é obrigatório!');
      return;
    }

    if(this.tel1 == "" && this.ddd1 == ""){
      if(this.tel2 == "" && this.ddd2 == ""){
        toastr.error('Pelomenos um Telefone e DDD é obrigatório!');
        return;
      }else{
        if(this.ddd2.length<2){
          toastr.error('Informe um DDD válido!');
          return;
        }
        if(this.tel2.length<8){
          toastr.error('Informe um Telefone válido!');
          return;
        }
      }
    }else{
      if(this.ddd1.length<2){
        toastr.error('Informe um DDD válido!');
        return;
      }
      if(this.tel1.length<8){
        toastr.error('Informe um Telefone válido!');
        return;
      }
    }

    let filtro = {
      cnpj: this.cnpj,
      nomeLoja: this.nomeLoja,
      nomeContato: this.nomeContato,
      ddd1:  this.ddd1,
      tel1: this.tel1,
      ddd2: this.ddd2,
      tel2: this.tel2,
      cdfzs: this.userLogado.setor,

    }

    this.cartaoService.saveClienteCartao(filtro).subscribe(
      resp=> {
              toastr.success("Cliente cartão salvo");
              this.getClients();
            },
      error => {
              toastr.error(error)
            }
    )

  }
  resetFilters(){
    this.cnpj = "";
    this.nomeContato = "";
    this.nomeLoja = "";
    this.tel1 = "";
    this.tel2 = "";
    this.ddd1 = "";
    this.ddd2 = "";
  }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  getClients() {
    this.isRequesting = true;

    // const parametersVendedor = { ...this.parameters2 };

    if(this.userLogado.setor != undefined){

      let filtro = {
        cdfzs: this.userLogado.setor,
      }
        // parametersVendedor.vendedor = parametersVendedor.vendedor.setor;

      this.cartaoService.getListCartaoCliente(filtro).subscribe(
        data => {
          this.isRequesting = false;

          this.lsClients = data;
        },
        error => console.log(error)
      );
    }
  }

}
